<template>
  <v-skeleton-loader
    class="full-height-image-skeleton-loader"
    type="image"
    transition="fade-transition"
  />
</template>

<script>
export default {
  name: "FullHeightImageSkeletonLoader",
};
</script>

<style scoped>
.full-height-image-skeleton-loader,
.full-height-image-skeleton-loader >>> .v-skeleton-loader__image {
  height: 100%;
}
</style>
